import { SeriesList } from '@/components/series'
import { useLabels } from '@/lib/terminology'

export function SeriesPage() {
  const labels = useLabels()

  return (
    <div className="p-6">
      <div className="mb-6">
        <h1 className="text-2xl font-semibold text-zinc-900 dark:text-zinc-100">{labels.collections}</h1>
      </div>

      <SeriesList />
    </div>
  )
}
